module.exports = __webpack_public_path__ + "static/media/6@1920w.9f740a71.jpg";